var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-9 my-auto" }, [
      _c("h2", { staticClass: "page-header" }, [
        _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-3 my-auto" }, [
      _c("div", { staticClass: "d-flex flex-row client justify-content-end" }, [
        _c(
          "div",
          { staticClass: "p-0 d-none d-lg-flex flex-row button-wrapper" },
          [
            _c("simple-button", {
              attrs: { text: _vm.$t("lists.createList") },
              on: { click: _vm.toCreateList },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "dropleft position-static" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown-menu" }, [
            _c("div", { staticClass: "dropdown-item clickable wide" }, [
              _c(
                "button",
                {
                  staticClass: "btn text-danger",
                  attrs: { type: "button" },
                  on: { click: _vm.toCreateList },
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("lists.createList")) +
                      "\n            "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-9" }, [
      _c("h6", { staticClass: "grey-text text-darken-1" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("lists.viewLists")) + "\n    "),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "grey-text text-darken-4 clickable d-lg-none",
        attrs: { "data-toggle": "dropdown" },
      },
      [_c("i", { staticClass: "material-icons" }, [_vm._v("more_vert")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }